import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { fetchCsrfCookie } from '../../../../../redux/action/csrf/csrf-cookie';
import { fetchDeleteNews } from '../../../../../redux/action/homePage/news/deleteNews';

const DeleteModal = (props) => {
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const DeleteNews = () => {
        dispatch(fetchCsrfCookie())
        dispatch(fetchDeleteNews(props.id))
        props.update()
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    <Modal.Header>
                        <Modal.Title>{t("delete this item")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleClick}>
                            {t("Cancel")}
                        </Button>
                        <Button variant="danger" onClick={DeleteNews}>
                            {t("confirm")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default DeleteModal
